(() => {
  const SPLIT_FILTER_CONFIG = {
    processing: {
      metafieldKeys: ['custom.processing'],
      separator: '/',
    },
    varieties: {
      metafieldKeys: ['custom.varieties'],
      separator: ',',
    },
  };

  const CONTROL_SELECTOR = '[data-split-filter-control]';
  const GROUP_SELECTOR = '[data-split-filter-group]';
  const NATIVE_SELECTOR = '[data-split-filter-native]';
  let syncQueued = false;

  const getGroupConfig = (group) => {
    if (!group) return null;

    const config = SPLIT_FILTER_CONFIG[group.dataset.splitFilterType];
    if (!config) return null;

    const paramName = String(group.dataset.splitFilterParam || '').toLowerCase();

    if (!paramName) return config;

    return config.metafieldKeys.some((key) => paramName.includes(key))
      ? config
      : null;
  };

  const getControls = (group) => Array.from(group.querySelectorAll(CONTROL_SELECTOR));

  const getSelectedValues = (group) => new Set(
    getControls(group)
      .filter((control) => control.checked && !control.disabled)
      .map((control) => control.dataset.splitFilterValue)
      .filter(Boolean)
  );

  const syncGroupNativeInputs = (group) => {
    if (!getGroupConfig(group)) return;

    const selectedValues = getSelectedValues(group);

    group.querySelectorAll(NATIVE_SELECTOR).forEach((input) => {
      const rawValues = String(input.dataset.splitFilterValues || '')
        .split('||')
        .filter(Boolean);

      input.disabled = !rawValues.some((value) => selectedValues.has(value));
    });
  };

  const applyUrlStateToGroup = (group, searchParams = new URLSearchParams(window.location.search)) => {
    if (!getGroupConfig(group)) return;

    const controls = getControls(group);
    const splitParam = controls.find((control) => control.name)?.name;

    if (!splitParam || !searchParams.has(splitParam)) {
      syncGroupNativeInputs(group);
      return;
    }

    const selectedValues = new Set(searchParams.getAll(splitParam));

    controls.forEach((control) => {
      control.checked = !control.disabled && selectedValues.has(control.value);
    });

    syncGroupNativeInputs(group);
  };

  const syncAllGroups = () => {
    const searchParams = new URLSearchParams(window.location.search);

    document.querySelectorAll(GROUP_SELECTOR).forEach((group) => {
      applyUrlStateToGroup(group, searchParams);
    });
  };

  const scheduleSyncAllGroups = () => {
    if (syncQueued) return;

    syncQueued = true;
    window.requestAnimationFrame(() => {
      syncQueued = false;
      syncAllGroups();
    });
  };

  const submitFilterForm = (form, control) => {
    if (!form) return;

    if (control?.id) {
      control.focus();
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  };

  document.addEventListener('change', (event) => {
    const control = event.target.closest(CONTROL_SELECTOR);
    if (!control) return;

    const group = control.closest(GROUP_SELECTOR);
    if (!group) return;
    if (!getGroupConfig(group)) return;

    syncGroupNativeInputs(group);

    submitFilterForm(control.closest('form'), control);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllGroups, { once: true });
  } else {
    syncAllGroups();
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => Array.from(mutation.addedNodes).some(
      (node) => node.nodeType === Node.ELEMENT_NODE
        && (node.matches?.(GROUP_SELECTOR) || node.querySelector?.(GROUP_SELECTOR))
    ))) {
      scheduleSyncAllGroups();
    }
  });

  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
